import { ChevronRight } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import CodeSnippetInline from "ds/components/CodeSnippetInline";

import { showModuleVersionInputsCodeDrawer } from "../CodeDrawer";

type ModuleVersionInputsCodePreviewProps = {
  code: string;
  title: string;
};

const ModuleVersionInputsCodePreview = ({ code, title }: ModuleVersionInputsCodePreviewProps) => {
  const isMultiline = code.includes("\n");

  const handleShowFullCode = () => {
    showModuleVersionInputsCodeDrawer({ code, title });
  };

  return (
    <Box align="center" gap="small" fullWidth>
      <CodeSnippetInline>{code.replace(/\s+/g, " ")}</CodeSnippetInline>
      {isMultiline && (
        <ButtonIcon variant="ghost" icon={ChevronRight} onPress={handleShowFullCode}>
          {`Show full ${title}`}
        </ButtonIcon>
      )}
    </Box>
  );
};

export default ModuleVersionInputsCodePreview;
